import { z } from 'zod';
import { CoreCustomListViewSortDirectionSchema } from '../inputTypeSchemas/CoreCustomListViewSortDirectionSchema'

/////////////////////////////////////////
// CORE CUSTOM LIST VIEW SORT FIELD SCHEMA
/////////////////////////////////////////

export const CoreCustomListViewSortFieldSchema = z.object({
  direction: CoreCustomListViewSortDirectionSchema,
  id: z.number().int(),
  listViewId: z.number().int(),
  fieldName: z.string(),
  fieldId: z.number().int().nullable(),
  order: z.number().int(),
})

export type CoreCustomListViewSortField = z.infer<typeof CoreCustomListViewSortFieldSchema>

export default CoreCustomListViewSortFieldSchema;
